import axios, { CreateAxiosDefaults } from "axios";
import { getSureApiUrl } from "./utils";
import { getInexwebInfo } from "src/utils/token";
import i18next from "i18next";

const adminConfig: CreateAxiosDefaults = {
    baseURL: getSureApiUrl(),
    headers: {
        common: {
            "Content-Type": "application/ld+json",
            Accept: "application/ld+json",
        },
    },
};

export const sureApiCall = axios.create({ ...adminConfig });

sureApiCall.interceptors.request.use((config) => {
    const locale = i18next.resolvedLanguage;
    config.headers["X-Locale"] = locale ?? "fr";

    return config;
});

const inexwebConfig: CreateAxiosDefaults = {
    baseURL: getSureApiUrl(),
    headers: {
        common: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    },
};
export const inexwebApiCall = axios.create({ ...inexwebConfig });

inexwebApiCall.interceptors.request.use(
    // onFullfill
    (config) => {
        const token = getInexwebInfo();
        config.headers["X-Token"] = token.token;
        config.headers["X-Company"] = token.company;

        return config;
    },
    // onError
    async (error) => {
        // The Error behavior is not very clear, so we do nothing.
        console.error("Error inside Axios Client: ", error);
    },
);
